// extracted by mini-css-extract-plugin
module.exports = {"root":"FotorLoading_root__MZkOI"};